
// elements with display:flex are focusable in IE10-11
export default {
  element: 'span',
  mutate: function mutate(element) {
    element.setAttribute('style', 'display: -webkit-flex; display: -ms-flexbox; display: flex;');
    element.innerHTML = '<span style="display: block;">hello</span>';
  }
};
//# sourceMappingURL=focus-flexbox-container.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ally.js/esm/supports/focus-flexbox-container.js
// module id = 181
// module chunks = 0 1